// extracted by mini-css-extract-plugin
export var card = "_va-0";